function isLandingPage(pathname) {
  if ( pathname === "/" || pathname == "/investigations/china-the-superpower-of-seafood/") {
    return true;
  }
  return false;
}

export default isLandingPage;